// Port of api/fuel/app/classes/filter/package/games/play/data/games/players/user.php
import F from 'offline/filter/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'
export default {
	require: function(config, filter) { return config.ownerType === F.OWNER_USER && filter.play && filter.play.group },
	run: function(filter, data, config, global) {
		var userId = global.userIndex[0]
		var identify = ['p.user_id <> l.user_id']
		var ownerConfig = Config.user(userId)
		var usernames = ownerConfig && ownerConfig.plays && ownerConfig.plays.usernames ? ownerConfig.plays.usernames : []

		for (var i = 0; i < usernames.length; i++) {
			identify.push("l.player_name <> '" + String(usernames[i]).replace(/'/g, "''") + "'")
		}

		var sql = 'SELECT p.game_id AS g, SUM(p.play_count) AS p, SUM(p.play_result * p.play_count) AS r, SUM(l.player_win) AS w, l.user_id AS u, l.player_name AS n, l.player_username AS un FROM play p JOIN player l ON p.play_id = l.play_id AND (' + identify.join(' AND ') + ') WHERE p.game_id IN(' + Util.in(global.resultIndex) + ') AND p.user_id = ' + userId + " AND (l.user_id <> 0 OR l.player_name <> '' OR l.player_username <> '')"
		if (global.playContextIndex) sql += ' AND p.play_id IN(' + Util.in(global.playContextIndex) + ')'
		sql += ' GROUP BY p.game_id, l.user_id, l.player_name, l.player_username'
		global.players = Util.query(sql, false, 'g', true)
		return global
	}
}
